import { useStores } from "../../../../core/stores/rootStore";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { action } from "mobx";
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import Card from 'react-bootstrap/Card';
import 'react-toastify/dist/ReactToastify.css';
import DateFormatted from './../../../../shared/components/dateFormatted';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { formatMonthYear } from './../../../../utils';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Skeleton from 'react-loading-skeleton';
import { isNumberKey, isZeroOne, isNumber2Decimals, isWeekendByDate, getDayNameFromDate, setConfig } from './../../../../utils';
import classnames from 'classnames';
import { NumericFormat, NumberFormatBase } from 'react-number-format';

const ExpensesWithPackageForm = () => {

    let navigate = useNavigate();
    const { year, month, devId } = useParams();
    const { t } = useTranslation();
    const { expensesWithPakageFormStore, loginStore } = useStores();
    const { packageExpense, getPackageExpense, save, generate, criteria, isLoading, getTotalKms, getTotalBreakfast, getTotalLunch, getTotalDinner, getTotalLodging, getTotalPhoneAndITPackage } = expensesWithPakageFormStore;
    const { accountInfo } = loginStore;

    useEffect(() => {
        getPackageExpense(year, month, devId);
    }, []);

    return (
        <div>
            <Card>
                <Card.Body>
                    <Row>
                        <Col xs={4}>
                            <div style={{ alignSelf: "center" }}>
                                <ArrowBackIosIcon disabled={isLoading} sx={{ color: "#d12b3c", cursor: "pointer" }} onClick={() => navigate(-1)} size="small" />
                            </div>
                        </Col>
                        <Col xs={4} className="text-center">
                            {isLoading ? <Skeleton width={300} /> : <h5>{formatMonthYear(new Date(criteria.year, criteria.month, 1))}</h5>}
                        </Col>
                        <Col xs={4}>
                            {(
                                (accountInfo.role == 1 && (packageExpense.status == 0 || packageExpense.status == 1)) ||
                                (accountInfo.role == 3 && (packageExpense.status == 0 || packageExpense.status == 3) && accountInfo.salaryWinbiz)
                            ) && (
                                    <>
                                        <span className="ms-auto" />

                                        <button disabled={isLoading} className="float-end btn btn-secondary" type="button"
                                            onClick={() => { save().then(() => { window.location.reload(); }) }}>
                                            {t('save')}
                                        </button>

                                        <button disabled={isLoading} className="float-end btn btn-secondary" type="button"
                                            style={{ marginRight: '10px' }}
                                            onClick={generate}>
                                            {t('generate')}
                                        </button>
                                    </>
                                )
                            }

                            <button disabled={isLoading} className="float-end btn btn-danger" type="button"
                                style={{ marginRight: '10px' }}
                                onClick={() => navigate(-1)}>
                                {t('cancel')}
                            </button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <Card className="mt-2 cost-expense-list">
                <Card.Body>
                    <fieldset disabled={
                        (accountInfo.role == 1 && packageExpense.status != 0 && packageExpense.status != 1) ||
                        (accountInfo.role == 3 && packageExpense.status != 0 && packageExpense.status != 3 && !accountInfo.salaryWinbiz)
                    }>
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th style={{ width: '10%' }}>{t('date')}</th>
                                    <th style={{ width: '30%' }}>{t('description')}</th>
                                    <th style={{ width: '10%' }}>{t('km')}</th>
                                    <th style={{ width: '10%' }}>{t('breakfast')}</th>
                                    <th style={{ width: '10%' }}>{t('lunch')}</th>
                                    <th style={{ width: '10%' }}>{t('dinner')}</th>
                                    <th style={{ width: '10%' }}>{t('lodging')}</th>
                                    <th style={{ width: '10%' }}>{t('telAndInfo')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    isLoading ?
                                        (
                                            Array.from(Array(30), (e, i) => {
                                                return <tr key={i}>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                </tr>
                                            })
                                        )
                                        :
                                        packageExpense.items.map((expense, index) => (
                                            <tr style={{ verticalAlign: "middle", height: '23px' }} className={classnames({ 'weekend': isWeekendByDate(expense.date) })} key={index}>
                                                <td style={{ fontSize: '0.74rem' }} >
                                                    {getDayNameFromDate(new Date(expense.date))}  <DateFormatted date={expense.date} />
                                                </td>
                                                <td>
                                                    <input disabled={index == 0}
                                                        className="form-control"
                                                        value={index === 0 ? t('telephoneIT') : expense.description}
                                                        type="text"
                                                        onChange={action((e) => {
                                                            expense.description = e.target.value;
                                                        })}
                                                    />
                                                </td>
                                                <td>
                                                    {index !== 0 ?
                                                        <NumericFormat
                                                            disabled={index == 0}
                                                            className="form-control"
                                                            value={expense.kms}
                                                            onValueChange={action((values, sourceInfo) => {
                                                                if (values.value === "-") {
                                                                    expense.kms = values.value;
                                                                    return;
                                                                }
                                                                expense.kms = parseInt(values.value);
                                                            })}
                                                            isAllowed={(values) => {
                                                                const { floatValue, value } = values;

                                                                return value === "-" || Number.isInteger(floatValue);
                                                            }}
                                                            allowNegative={true}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Backspace" || e.key === "Delete") {
                                                                    expense.kms = "";
                                                                }
                                                                if (e.keyCode === 190) { e.preventDefault(); e.stopPropagation(); }
                                                            }}
                                                        />
                                                        :
                                                        <></>
                                                    }
                                                </td>
                                                <td>
                                                    {index !== 0 ?
                                                        <NumericFormat
                                                            className="form-control"
                                                            value={expense.breakfast}
                                                            onValueChange={action((values, sourceInfo) => {
                                                                if (values.value === "-") {
                                                                    expense.breakfast = values.value;
                                                                    return;
                                                                }

                                                                expense.breakfast = parseInt(values.value);
                                                            })}
                                                            isAllowed={(values) => {
                                                                const { floatValue, value } = values;
                                                                return value === "-" || Number.isInteger(floatValue);
                                                            }}
                                                            allowNegative={true}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Backspace" || e.key === "Delete") {
                                                                    expense.breakfast = "";
                                                                }
                                                                if (e.keyCode === 190) { e.preventDefault(); e.stopPropagation(); }
                                                            }}
                                                        />
                                                        :
                                                        <></>
                                                    }
                                                </td>
                                                <td>
                                                    {index !== 0 ?
                                                        <NumericFormat
                                                            className="form-control"
                                                            value={expense.lunch}
                                                            onValueChange={action((values, sourceInfo) => {
                                                                if (values.value === "-") {
                                                                    expense.lunch = values.value;
                                                                    return;
                                                                }
                                                                expense.lunch = parseInt(values.value);
                                                            })}
                                                            isAllowed={(values) => {
                                                                const { floatValue, value } = values;
                                                                return value === "-" || Number.isInteger(floatValue);
                                                            }}
                                                            allowNegative={true}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Backspace" || e.key === "Delete") {
                                                                    expense.lunch = "";
                                                                }
                                                                if (e.keyCode === 190) { e.preventDefault(); e.stopPropagation(); }
                                                            }}
                                                        />
                                                        :
                                                        <></>
                                                    }
                                                </td>
                                                <td>
                                                    {index !== 0 ?
                                                        <NumericFormat
                                                            className="form-control"
                                                            value={expense.dinner}
                                                            onValueChange={action((values, sourceInfo) => {
                                                                if (values.value === "-") {
                                                                    expense.dinner = values.value;
                                                                    return;
                                                                }
                                                                expense.dinner = parseInt(values.value);
                                                            })}
                                                            isAllowed={(values) => {
                                                                const { floatValue, value } = values;
                                                                return value === "-" || Number.isInteger(floatValue);
                                                            }}
                                                            allowNegative={true}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Backspace" || e.key === "Delete") {
                                                                    expense.dinner = "";
                                                                }
                                                                if (e.keyCode === 190) { e.preventDefault(); e.stopPropagation(); }
                                                            }}
                                                        />
                                                        :
                                                        <></>
                                                    }
                                                </td>
                                                <td>
                                                    {index !== 0 ?
                                                        <NumericFormat
                                                            className="form-control"
                                                            value={expense.lodging}
                                                            onValueChange={action((values, sourceInfo) => {
                                                                if (values.value === "-") {
                                                                    expense.lodging = values.value;
                                                                    return;
                                                                }

                                                                expense.lodging = parseInt(values.value);
                                                            })}
                                                            isAllowed={(values) => {
                                                                const { floatValue, value } = values;
                                                                return value === "-" || Number.isInteger(floatValue);
                                                            }}
                                                            allowNegative={true}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Backspace" || e.key === "Delete") {
                                                                    expense.lodging = "";
                                                                }
                                                                if (e.keyCode === 190) { e.preventDefault(); e.stopPropagation(); }
                                                            }}
                                                        />
                                                        :
                                                        <></>
                                                    }
                                                </td>
                                                <td>
                                                    {index == 0 ?
                                                        <NumericFormat
                                                            className="form-control"
                                                            value={expense.phoneAndITPackage}
                                                            decimalSeparator="."
                                                            thousandSeparator="'"
                                                            decimalScale={2}
                                                            onValueChange={action((values, sourceInfo) => {
                                                                if (values.value === "-") {
                                                                    expense.lodging = values.value;
                                                                    return;
                                                                }

                                                                expense.phoneAndITPackage = values.floatValue;
                                                            })}
                                                            allowNegative={true}
                                                            isAllowed={(values) => {
                                                                const { floatValue, value } = values;
                                                                return value === "-" || !Number.isNaN(floatValue);
                                                            }}
                                                        />
                                                        //<input
                                                        //    type="number"
                                                        //    className="form-control"
                                                        //    onBeforeInput={isNumber2Decimals}
                                                        //    defaultValue={Number(expense.phoneAndITPackage).toFixed(2)}
                                                        //    onChange={action((e) => { expense.phoneAndITPackage = Number(e.target.value) })}
                                                        ///>
                                                        :
                                                        <></>
                                                    }
                                                </td>
                                            </tr>
                                        ))
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td><b>{t('total')}</b></td>
                                    <td></td>
                                    <td><b>{getTotalKms}</b></td>
                                    <td><b>{getTotalBreakfast}</b></td>
                                    <td><b>{getTotalLunch}</b></td>
                                    <td><b>{getTotalDinner}</b></td>
                                    <td><b>{getTotalLodging}</b></td>
                                    <td><b>{getTotalPhoneAndITPackage}</b></td>
                                </tr>
                            </tfoot>
                        </table>
                    </fieldset>
                </Card.Body>
            </Card>
        </div >
    );
};

export default observer(ExpensesWithPackageForm);
